import { assert_number_gte_0, assert_string_not_empty, assert_type_boolean } from '@shared/asserts/utils_asserts';
import { DTO__word } from '@shared/dto/+word/word_translated/DTO__word';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO__number_range } from '../DTO__number_range';
import { DTO_GENERATION_SETTING__base } from '../primitive/DTO_GENERATION_SETTING__base';

export class DTO__token extends DTO_GENERATION_SETTING__base {
  static _class_name_static: string = ENUM__dto_class_name.TOKEN;

  /*
   * STATIC METHODS
   */

  static update_token_sign(target: DTO__token, source: DTO__token): DTO__token {
    return target.clone({
      is_positive: source.is_positive,
    });
  }

  static updateTokenWeight(target: DTO__token, source: DTO__token): DTO__token {
    return target.clone({
      weight: source.weight,
    });
  }

  static areTokenHaveEqualWeights(tokens: DTO__token[]): boolean {
    if (tokens.is_empty()) return false;
    if (tokens.length == 1) return true;

    const firstWeight = tokens[0].weight;
    return tokens.every(token => token.weight === firstWeight);
  }

  static sort_by_weight(a: DTO__token, b: DTO__token): number {
    if (a.is_positive !== b.is_positive) {
      return a.is_positive ? -1 : 1;
    }

    return a.weight - b.weight;
  }

  static sortByWordTranslated(a: DTO__token, b: DTO__token): number {
    if (a.is_positive !== b.is_positive) {
      return a.is_positive ? -1 : 1;
    }

    let word_a = a.word.word_translated ? a.word.word_translated : a.word_english;
    let word_b = b.word.word_translated ? b.word.word_translated : b.word_english;

    return word_a.localeCompare(word_b);
  }

  /*
   * INSTANCE FIELDS
   */
  word_english!: string;

  is_positive!: boolean;
  weight!: number;
  weight_range!: DTO__number_range;

  /*
   * CLIENT RUNTIME FIELDS
   */
  word!: DTO__word;

  /*
   * METHODS
   */
  get_word_string(language: string, use_english: boolean): string {
    let out = this.word_english;

    if (language == ENUM__language_type.ENGLISH) return out; // language in settings is english
    if (use_english) return out; // user uses english for tokens
    if (!this.word.word_translated) return out; // word is not translated yet
    if (this.word.language != language) return out; // we dont have translation for this language here yet. this case should be never triggered by design

    out = this.word.word_translated;

    return out;
  }

  is_one_word(): boolean {
    return !this.word_english.trim().includes(' ');
  }

  is_equal(other: DTO__token): boolean {
    return this.word_english == other.word_english;
  }

  assert_standard_fields(): void {
    assert_string_not_empty(this.word_english);

    assert_type_boolean(this.is_positive);

    assert_number_gte_0(this.weight);
  }
}
